export default {
  Layout: {
    Prefix: 'LAYOUT_',
    AddBreadCrumbKey: 'LAYOUT_ADDBREADCRUMBKEY',
    ClearBreadCrumbKeys: 'LAYOUT_CLEARBREADCRUMBKEYS'
  },
  CurrentSession: {
    Prefix: 'CURRENTSESSION_',
    ClearUser: 'CURRENTSESSION_CLEARUSER',
    SetUser: 'CURRENTSESSION_SETUSER',
    ClearSettings: 'CURRENTSESSION_CLEARSETTINGS',
    SetSettings: 'CURRENTSESSION_SETSETTINGS',
    ClearAccount: 'CURRENTSESSION_CLEARACCOUNT',
    SetAccount: 'CURRENTSESSION_SETACCOUNT',
    UpdateAccount: 'CURRENTSESSION_UPDATEACCOUNT'
  },
  Notifications: {
    Show: 'NOTIFICATIONS_SHOWMESSAGE',
    Clear: 'NOTIFICATIONS_CLEARMESSAGE',
    LoadingShow: 'NOTIFICATIONS_LOADINGSHOWMESSAGE',
    LoadingClear: 'NOTIFICATIONS_LOADINGCLEARMESSAGE'
  },
  Drawer: {
    Prefix: 'DRAWER_',
    Show: 'DRAWER_SHOW',
    Hide: 'DRAWER_HIDE'
  },
  MessageStation: {
    Show: 'MESSAGESTATION_SHOW',
    Hide: 'MESSAGESTATION_HIDE'
  },
  AppState: {
    Prefix: 'APPSTATE_',
    SetValue: 'APPSTATE_SETVALUE',
    ClearValue: 'APPSTATE_CLEARVALUE',
    AppendArrayValue: 'APPSTATE_APPENDARRAYVALUE',
    UpdateArrayValue: 'APPSTATE_UPDATEARRAYVALUE',
    ClearArrayValue: 'APPSTATE_CLEARARRAYVALUE'
  },
  Modal: {
    Prefix: 'MODAL_',
    Show: 'MODAL_SHOW',
    Hide: 'MODAL_HIDE'
  },
  Router: {
    Prefix: 'ROUTER_',
    Push: 'ROUTER_PUSH',
    AddIndexRoute: 'ROUTER_ADDINDEXROUTE'
  }
}
